<p-dialog
    [(visible)]="visible"
    [modal]="true"
    [closable]="effectiveClosable()"
    [closeOnEscape]="effectiveCloseOnEscape()"
    [draggable]="false"
    [resizable]="false"
    [maximizable]="false"
    [blockScroll]="true"
    [style]="dialogStyle()"
    [styleClass]="styleClass()"
    [breakpoints]="breakpoints()"
    [appendTo]="appendTo()"
    (onShow)="applyInitialRequest()"
    (onHide)="onHide()">
  <ng-template pTemplate="header">
    <div class="flex align-items-center gap-2">
      <span class="font-bold text-xl">{{ i18n.i18nLng()['VIRTUALTERMINAL'] + ' - ' + i18n.i18nLng()['CREDITCARD_MOTO_PAY'] }}</span>
    </div>
  </ng-template>
  @if (error()) {
    <p-message severity="error" styleClass="w-full mb-3">{{ error()! }}</p-message>
  }
  <div class="mb-2 flex flex-row align-items-center gap-2">
    <sps-payment-status-tag [status]="paymentTypeStatus()"></sps-payment-status-tag>
    <div class="font-bold">
      {{ paymentTypeTitle() }}
    </div>
  </div>

  <!-- Payment initialization data -->
  <form class="p-fluid flex flex-column gap-3" (ngSubmit)="initSession()">
    <fieldset [disabled]="formDisabled()" class="border-none p-0 m-0 grid">
      <div class="col-12">
        <label for="orderId" class="block mb-1">{{ i18n.i18nLng()['PURPOSE'] }}</label>
        <input
            #orderIdField="ngModel"
            fluid
            pInputText
            id="orderId"
            name="orderId"
            maxlength="24"
            [(ngModel)]="orderIdInput"
            [disabled]="formDisabled()"
            required
            autocomplete="off"/>
      </div>
      <div class="col-9">
        <label for="amount" class="block mb-1">{{ i18n.i18nLng()['AMOUNT'] }}</label>
        <p-inputNumber
            #amountField="ngModel"
            fluid
            inputId="amount"
            name="amount"
            [(ngModel)]="amountInput"
            mode="decimal"
            required
            [minFractionDigits]="2"
            [maxFractionDigits]="2"
            [min]="0.01"
            [disabled]="formDisabled()"/>
      </div>
      <div class="col-3">
        <label for="currency" class="block mb-1">{{ i18n.i18nLng()['CURRENCY'] }}</label>
        <p-select
            fluid
            inputId="currency"
            name="currency"
            [options]="currencyOptions()"
            [(ngModel)]="currencyInput"
            [disabled]="formDisabled()"
            [readonly]="true"/>
      </div>
    </fieldset>
  </form>

  <!-- ifs data -->
  @if (step() === 'card') {
    <p-divider/>
    <h4 class="mt-0 mb-2 ml-2">{{ i18n.i18nLng()['CARDDETAILS'] }}</h4>
    <sps-ifs-credit-card
        [clientSession]="sessionId()"
        [clientConfiguration]="clientConfiguration()"
        [paymentTypeStatus]="paymentTypeStatus()"
        (ready)="onReady($event)"
        (errored)="onIfsError($event)"
        (formValidationChanged)="onFormValidationChanged($event)"
        (brandChanged)="onBrandChanged($event)"/>
  }
  @if (step() === 'done') {
    <p-message severity="success" styleClass="w-full mb-3 mt-3">{{ successText() }}</p-message>
  }
  <ng-template pTemplate="footer">
    @switch (step()) {
      @case ('form') {
        @if (showCancelButton()) {
          <p-button
              [label]="i18n.i18nLng()['CANCEL']"
              severity="secondary"
              [disabled]="initializing()"
              (onClick)="close()"/>
        }
        <p-button
            [label]="i18n.i18nLng()['NEXT']"
            icon="pi pi-arrow-right"
            iconPos="right"
            [loading]="initializing()"
            [disabled]="!formValid() || initializing()"
            (onClick)="initSession()"/>
      }
      @case ('card') {
        @if (showBackButton()) {
          <p-button
              [label]="i18n.i18nLng()['BACK']"
              severity="secondary"
              icon="pi pi-arrow-left"
              [disabled]="submitting()"
              (onClick)="backToForm()"/>
        }
        <p-button
            [label]="i18n.i18nLng()['PAY']"
            icon="pi pi-credit-card"
            [severity]="'primary'"
            [loading]="submitting()"
            [disabled]="!ifsInstance() || !ifsFormValid() || submitting()"
            (onClick)="pay()"/>
      }
      @case ('done') {
        <p-button
            [label]="doneLabel()"
            icon="pi pi-check"
            (onClick)="close(true)"/>
      }
    }
  </ng-template>
</p-dialog>
